<template>
	<router-view v-if="!loading"></router-view>
</template>

<script>
import {defineComponent, onMounted, ref} from "vue";
import {getSearchConfs} from "@/api/search";
import store from "@/store";
import Axios from "axios";
import {getToken} from "@/api/common";
import {isEmpty} from "lodash";
import {isNotEmpty} from "@/utils/util";
import {useRouter} from "vue-router";

export default defineComponent({
	name: "App",
	setup() {
		const loading = ref(true);
		onMounted(() => {
			loading.value = true;
			getDefaultConfig();
		})
		const router = useRouter();
    function getDefaultConfig() {
      // 此处获取默认配置和路由守卫处重复 原因 此处不知为何比beforeEach先执行 两边都做判断最为稳妥
      if(!store.state.config.local){
        Axios.get('/pdam/app/app.config.json')
            .then(res => {
              if (isNotEmpty(res)) {
                if (res && res.data) {
                  store.commit('setConfig', res.data); // 设置默认config数据
                }
                getToken1();
              } else {
                //跳转到服务正在维护中, 因为若基本的配置参数都无法获取, 那么整个应用也无法运行起来
                router.push('/error').then(() =>loading.value = false);
              }
            })
            .catch(err =>{
              console.error(err)
              //跳转到服务正在维护中, 因为若基本的配置参数都无法获取, 那么整个应用也无法运行起来
              router.push('/error').then(() =>loading.value = false);
            });
      }
      else{
        getToken1();
      }
    }
    function getBaseConfig() {
			getSearchConfs()
          .then(data => {
            if (!isEmpty(data)) {
              loading.value = false
              store.commit('setBaseConfig', data.baseConfs);
            } else {
              //跳转到服务正在维护中, 因为若基本的配置参数都无法获取, 那么整个应用也无法运行起来
              router.push('/error').then(() =>loading.value = false);
            }
          })
          .catch(err => {
            console.error(err);
            //跳转到服务正在维护中, 因为若基本的配置参数都无法获取, 那么整个应用也无法运行起来
            router.push('/error').then(() =>loading.value = false);
          });
		}

    function getToken1() {
			// 获取token
      getToken()
          .then(data => {
            if (isNotEmpty(data)) {
              store.commit('addToken', data);
              getBaseConfig();
            } else {
              //跳转到服务正在维护中, 因为若基本的配置参数都无法获取, 那么整个应用也无法运行起来
              router.push('/error').then(() =>loading.value = false);
            }
          })
          .catch((error) => {
            console.error(error)
            //跳转到服务正在维护中, 因为若基本的配置参数都无法获取, 那么整个应用也无法运行起来
            router.push('/error').then(() =>loading.value = false);
          });
		}
		
		return {loading}
	}
});
</script>